export default "__VITE_ASSET__BZ07lzLM__"